import React from 'react'

export default function PostStats({ content }) {
  const { pretitle, listItems } = content

  return (
    <section className='stats stats--dark'>
      <div className='stats__container'>
        <p className='stats__title'>{pretitle}</p>

        <ul className='list'>
          {listItems.map((item, i) => {
            const { label, number, detail } = item
            return (
              <li key={i} className='list__item'>
                {label && (
                  <span className='item__description-left'>{label}</span>
                )}
                <span className='item__number item__number--middle'>
                  {number}
                </span>
                {detail && <span className='item__detail'>{detail}</span>}
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
